
const url_server = (window.location.port==="3001"? "http://"+ window.location.hostname +":3035/"  :"/" );

export default url_server;